import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';
import Clock from 'components/Clock';
import { SupportInfo } from 'components/SupportInfo';

import {
  StyledProfileButtonsWrapper,
  StyledSettingsPage,
  StyledSettingsPageTitle,
} from 'components/Profile/StyledComponents';
import ProfileItem from 'components/Profile/ProfileItem';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import useModals from 'hooks/useModals';
import useCheckDefaultPin from './useCheckDefaultPin';
import i18n from 'i18n';

const SettingsPage = React.memo((props) => {
  const { items, history, match, isLoggedIn } = props;
  const { showLoginModal, showEnterPinModal, showCreatePinModal } = useModals();
  const check = useCheckDefaultPin();

  const handleEnter = useCallback(
    async (item) => {
      const focusBackConfig = {
        sectionToFocus: 'SETTINGS_LIST',
        elementToFocus: `#settings-item-${item.id}`,
      };

      if (item.id === 'parental-lock') {
        innerAnalyticsVolia.postEvent({
          eventGroup: 'profile',
          eventName: 'click parental control',
        });

        if (!isLoggedIn) return showLoginModal(focusBackConfig);

        const isDefaultPin = await check();

        if (isDefaultPin) {
          showCreatePinModal(focusBackConfig, () => history.push('/profile/parental-lock'));
        } else {
          showEnterPinModal(focusBackConfig, () => history.push('/profile/parental-lock'));
        }
      } else {
        history.push(`${match.url}/${item.path}`);
      }
    },
    [isLoggedIn, showLoginModal, check, showCreatePinModal, history, showEnterPinModal, match.url],
  );

  return (
    <StyledSettingsPage>
      <BackButton onEnter={history.goBack} />
      <Clock />
      <StyledSettingsPageTitle>{i18n.t('profile.settings')}</StyledSettingsPageTitle>
      <StyledProfileButtonsWrapper
        sectionName={'SETTINGS_LIST'}
        config={{ enterTo: 'last-focused' }}
        defaultSection
      >
        {items.map((item, index) => {
          const itemId = `settings-item-${item.id}`;
          return (
            <ProfileItem
              onEnter={() => handleEnter(item)}
              itemIndex={index}
              item={item}
              id={itemId}
              key={item.title}
            >
              {item.title}
            </ProfileItem>
          );
        })}
      </StyledProfileButtonsWrapper>
      <SupportInfo />
    </StyledSettingsPage>
  );
});

SettingsPage.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
};

export default SettingsPage;
